// extracted by mini-css-extract-plugin
export default {"header":"home_header__bDJ00"};